import Vue from 'vue';

const success = (resolve) => {
  resolve();
};

const failed = (errors, reject) => {
  reject(errors);
};

export default (appVersion) => {
  const data = new FormData();
  data.append('app_version', appVersion);
  const p = new Promise((resolve, reject) => {
    Vue.$http
    .request({
      url: 'user-app-version',
      data,
      method: 'post',
    })
    .then(() => {
      success(resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  });
  return p;
};



// WEBPACK FOOTER //
// ./src/app/services/account/updateUserAppVersion.js